import React, { useRef, useEffect, useState, useCallback } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { Col, Container, Form, Row } from "react-bootstrap";
import "./UserRegistration.css";
import useAuth from "../../hooks/useAuth";
// import Select from 'react-select';
import { useLocation } from 'react-router-dom';
import { fetchPranthList } from './pranthService'; // Adjust path as needed
import { useNavigate } from 'react-router-dom'; // Import useNavigate

const ADD_VIBHAG_TO_USER = "add-level-to-user";
const REMOVE_VIBHAG_TO_USER = "remove-level-from-user";

const AdminAddVibhagToUser = () => {
  const back = async (e) => {
    e.preventDefault();
    // setSuccess(false);
  };
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const userRef = useRef();
  const errRef = useRef();

  const { auth } = useAuth();

  const [errMsg, setErrMsg] = useState("");
  const [sucssMsg, setSucssMsg] = useState("");

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const personId = queryParams.get('person_id');
  const name = queryParams.get('name');
  const mobile = queryParams.get('mobile');
  const [error, setError] = useState(null);
  const [pranthList, setPranthList] = useState([]);
  const [selectedPranthId, setSelectedPranthId] = useState(1);
  const [vibhagList, setVibhagList] = useState([]);
  const [selectedVibhagId, setselectedVibhagId] = useState("");
  const [khandList, setKhandList] = useState([]);
  const [selectedKhandId, setSelectedKhandId] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const VibhagsOfVibhagUserPerPage = 15;
  const [VibhagsOfVibhagUser, setVibhagsOfVibhagUser] = useState([]);

  useEffect(() => {
    const getPranths = async () => {
      const data = await fetchPranthList(); // Get data from the service
      setPranthList(data);                  // Set data to state
    };

    getPranths();
  }, []);

  useEffect(() => {
    fetchPranthList();
  }, []);

  useEffect(() => {
    if (selectedPranthId) {
      fetchVibhagList(selectedPranthId).then((vibhags) => {
        if (vibhags.length > 0) {
          setselectedVibhagId(vibhags[0].vibhag_id);
        } else {
          setselectedVibhagId("");
          setVibhagList([]);
        }
      });
    }
  }, [selectedPranthId]);





  const fetchVibhagList = async (pranthId) => {
    try {
      const res = await axiosPrivate.get(`list-vibhags?pranth_id=${pranthId}`);
      const data = Array.isArray(res.data) ? res.data : [];
      setVibhagList(data);
      return data;
    } catch (err) {
      console.error("Failed to fetch Vibhag", err);
      setVibhagList([]);
      return [];
    }
  };






  const fetchVibhagsOfVibhagUser = useCallback(async () => {
    setError(null); // clear previous error
    try {
      const response = await axiosPrivate.get(`list-levels-of-user?person_id=${personId}`, {
        withCredentials: true,
      });
      setVibhagsOfVibhagUser(response.data);
      // setLoading(false);
    } catch (error) {
      console.error("Error fetching sthans of vibhag user:", error);
      setError(error?.response?.data?.message?.toString() || error?.message || "No sthans of vibhag user available.");
      // setLoading(false);
    }
  }, [axiosPrivate, personId]); // 👈 dependency added

  useEffect(() => {
    fetchVibhagsOfVibhagUser();
  }, [personId]);

  const AddVibhagToUserSubmit = async (e) => {
    e.preventDefault();

    try {
      var data = JSON.stringify({
        level_id: selectedVibhagId,
        person_id: personId,
        role: "Vibhag",

      });

      const response = await axiosPrivate.post(ADD_VIBHAG_TO_USER, data, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      });

      showMessage('success', response?.data?.message);


      fetchVibhagsOfVibhagUser();
    } catch (err) {

      if (!err?.response) {
        setErrMsg("No Server Response");
      } else if (err.response?.data?.message) {
        const errorMsg = typeof err.response.data.message === 'string'
          ? err.response.data.message
          : err.response.data.message.msg || "Unknown error"; // Extract inner msg if object
        setErrMsg(errorMsg);
      } else {
        setErrMsg("Registration Failed");
      }
    }

  };


  const RemoveVibhagFromUser = async (e, vibhagId, personId) => {
    e.preventDefault();
    try {
      const data = JSON.stringify({
        level_id: vibhagId,
        person_id: personId,
        role: "Vibhag",
      });



      const response = await axiosPrivate.post(REMOVE_VIBHAG_TO_USER, data, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      });

      showMessage('success', response?.data?.message);
      fetchVibhagsOfVibhagUser();
    } catch (err) {
      if (!err?.response) {
        setErrMsg("No Server Response");
      } else if (err.response?.data?.message) {
        const errorMsg = typeof err.response.data.message === 'string'
          ? err.response.data.message
          : err.response.data.message?.msg || "Unknown error";
        setErrMsg(errorMsg);
      } else {
        setErrMsg("Operation Failed");
      }
    }
  };


  const showMessage = (type, message) => {
    if (type === 'error') {
      setErrMsg(message);
      setSucssMsg(""); // ensure success message is cleared
    } else if (type === 'success') {
      setSucssMsg(message);
      setErrMsg(""); // ensure error message is cleared
    }

    // Auto-hide after 10 seconds
    setTimeout(() => {
      setErrMsg("");
      setSucssMsg("");
    }, 10000); // 10000ms = 10 seconds
  };



  const indexOfLastVibhagsOfVibhagUser = currentPage * VibhagsOfVibhagUserPerPage;
  const indexOfFirstVibhagsOfVibhagUser = indexOfLastVibhagsOfVibhagUser - VibhagsOfVibhagUserPerPage;
  const currentVibhagsOfVibhagUser = VibhagsOfVibhagUser.slice(indexOfFirstVibhagsOfVibhagUser, indexOfLastVibhagsOfVibhagUser);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const totalPages = Math.ceil(VibhagsOfVibhagUser.length / VibhagsOfVibhagUserPerPage);

  return (
    <>
      <Container>

        <button onClick={() => navigate(-1)} className="btn btn-secondary newviewbtn"> ← Back</button>
        <section className="userregbody2">

          <p
            ref={errRef}
            className={errMsg ? "errmsg" : "offscreen"}
            aria-live="assertive"
          >
            {errMsg}
          </p>

          <p
            ref={errRef}
            className={sucssMsg ? "sucssmsg" : "offscreen"}
            aria-live="assertive"
          >
            {sucssMsg}
          </p>


          <div className="wrapper wrapper2 new_arthiksakha">
            <form>
              <h3 class="arthik_head">Add new vibhag to <span class="colorChange">{name}</span></h3>

              <p className="arthik_head">Phone: {mobile}</p>
              <form onSubmit={AddVibhagToUserSubmit}>

                <Row>
                  <Col md={12}>

                    <Form.Label className="newformstyle">Select Vibhag</Form.Label>
                    <Form.Select
                      className="newselectstyle"
                      value={selectedVibhagId}
                      onChange={(e) => {
                        const VibhagId = e.target.value;
                        setselectedVibhagId(VibhagId);
                      }}
                      disabled={!vibhagList.length}
                    >
                      <option value="">-- Select Vibhag --</option>
                      {Array.isArray(vibhagList) &&
                        vibhagList.map((v) => (
                          <option key={v.vibhag_id} value={v.vibhag_id}>
                            {v.vibhag_name}
                          </option>
                        ))}
                    </Form.Select>
                  </Col>

                </Row>
              </form>

              <button
                type="button" // Important to prevent form submit
                className="btn"
                onClick={AddVibhagToUserSubmit} // Call this for "Sign Up"
                disabled={!selectedVibhagId}
              >
                Submit
              </button>
            </form>

          </div>

          <br></br>
          <div className="wrapperemp2">
            {/* <button onClick={handleRedirect} type="button" className="btn btn-success ms-auto d-block top-bt">+ Create Vibhag</button> */}
            <h3>List Vibhags of {name}</h3>

            <div className="table-container">
              <table id="customers">
                <thead>
                  <tr>
                    <th>Vibhag name (Malayalam)</th>
                    <th>Vibhag name</th>
                    <th>Options</th>
                  </tr>
                </thead>

                <tbody>
                  {error ? (
                    <tr>
                      <td colSpan="6" className="text-danger text-center">
                        {error}
                      </td>
                    </tr>
                  ) : VibhagsOfVibhagUser.length === 0 ? (
                    <tr>
                      <td colSpan="6">No Data available.</td>
                    </tr>
                  ) : (
                    currentVibhagsOfVibhagUser.map(VibhagOfVibhagUser => (
                      <tr key={VibhagOfVibhagUser.level_id}>
                        <td>{VibhagOfVibhagUser.level_name}</td>
                        <td>{VibhagOfVibhagUser.search_tag}</td>


                        <td>
                          <button class="btn btn-danger" onClick={(e) => RemoveVibhagFromUser(e, VibhagOfVibhagUser.level_id, VibhagOfVibhagUser.person_id)}>
                            Remove Vibhag
                          </button>

                        </td>
                      </tr>
                    ))
                  )}
                </tbody>


              </table>
            </div>

            {totalPages > 1 && (
              <div className="pagination">
                <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>Previous</button>
                {Array.from({ length: totalPages }, (_, index) => (
                  <button
                    key={index}
                    onClick={() => handlePageChange(index + 1)}
                    disabled={currentPage === index + 1}
                  >
                    {index + 1}
                  </button>
                ))}
                <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>Next</button>
              </div>
            )}
          </div>
        </section>
        {/* )} */}
      </Container >
    </>
  );
};

export default AdminAddVibhagToUser;
